/* eslint-disable */
// @ts-nocheck
import React from 'react';
import { useI18n } from 'react-simple-i18n';
import appstate, { getLocaledString } from '../appstate';
import tw1 from '../assets/img/asgas.webp';

function MeasuresQuiz2() {
	const { t } = useI18n();

	const initialQuestionsAndAnswers = () => {
		const questions = Object.values(
			appstate.currentLangData()?.quiz2?.questions || {},
		);

		return questions.map((q) => {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			const { question, answers } = q;

			return {
				question,
				answers,
				chosenAnswer: undefined,
			};
		});
	};

	const getAnswersArray = (answers: object) => {
		return Object.values(answers).map((a) => {
			return a;
		});
	};

	const getMeasuresForAnswers = () => {
		// Todo...
		return [
			...Object.values(appstate.currentLangData().quiz2.measures).map(
				(a) => {
					return a;
				},
			),
		];
	};

	const [isStarted, setIsStarted] = React.useState(false);
	const [isFinished, setIsFinished] = React.useState(false);
	const [currentQuestion, setCurrentQuestion] = React.useState(0);
	const [questionsAndAnswers, setQuestionsAndAnswers] = React.useState(
		initialQuestionsAndAnswers(),
	);
	const [expandedMeasures, setExpandedMeasures] = React.useState<string[]>(
		[],
	);

	const resetAnswersInLocalStorage = () => {
		localStorage.removeItem('quiz2Answers');
	};

	const saveAnswersToLocalStorage = () => {
		localStorage.setItem(
			'quiz2Answers',
			JSON.stringify(questionsAndAnswers),
		);
	};

	const getAnswersFromLocalStorage = () => {
		if (!localStorage.getItem('quiz2Answers')) {
			return undefined;
		}

		const answers = JSON.parse(
			localStorage.getItem('quiz2Answers') || '[]',
		);

		return answers;
	};

	// When the component mounts, we check if there are answers in local storage
	React.useEffect(() => {
		const answers = getAnswersFromLocalStorage();

		try {
			questionsAndAnswers.map((q, i) => {
				return {
					...q,
					chosenAnswer: answers[i].chosenAnswer,
				};
			});
		} catch (e) {
			resetAnswersInLocalStorage();
		}

		if (answers) {
			setQuestionsAndAnswers(
				questionsAndAnswers.map((q, i) => {
					return {
						...q,
						chosenAnswer: answers[i]?.chosenAnswer,
					};
				}),
			);

			setIsStarted(true);
			setIsFinished(true);
		}
	}, []);

	const points = () => {
		const points = questionsAndAnswers.reduce((acc, qa) => {
			if (qa.chosenAnswer === getLocaledString('Da', 'Yes')) {
				return acc + 1;
			} else if (
				qa.chosenAnswer === getLocaledString('Včasih', 'Sometimes')
			) {
				return acc + 0.5;
			}
			return acc;
		}, 0);

		return points;
	};

	if (!isStarted) {
		return (
			<div
				className={
					'w-full cloud-bg text-secondary-800 text-primary-700 h-124 rounded shadow border overflow-hidden p-8 flex flex-col justify-center items-center gap-8 pb-24 relative pt-20 -mb-12'
				}
			>
				<div
					className={
						'absolute w-full h-full top-0 left-0 z-0 opacity-15 blur-sm'
					}
					style={{
						backgroundImage: `url(${tw1})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				/>
				<button
					className={'button-primary mt-3 z-20'}
					onClick={() => {
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						window['gtag']('event', 'user_engagement', {
							event_category: 'quiz',
							event_label: 'quiz started',
						});
						setIsStarted(true);
					}}
				>
					{appstate.currentLanguage() === 'slSI'
						? 'Prični z reševanjem'
						: 'Take the quiz'}
				</button>
			</div>
		);
	}

	if (isFinished) {
		return (
			<div
				className={
					'w-full cloud-bg kviq text-black h-124 mt-4 rounded shadow overflow-y-scroll p-8 relative -mb-12'
				}
			>
				<div className={'text-xs lg:text-lg px-4'}>
					{points() <= 4 &&
						(appstate.currentLanguage() === 'slSI' ? (
							<div>
								<p>
									Uspeli ste doseči zadovoljstvo na delovnem
									mestu in učinkovito upravljate s stresom.
									Pomembno je, da to stanje tudi
									za&scaron;čitite in obdržite. S takim
									namenom je odlično, če sledite
									personaliziranemu načrtu za upravljanje s
									stresom, ki ga z lahkoto pripravite sami.
									Načrt lahko vsebuje samo dve temeljni
									kategoriji:&nbsp;
								</p>
								<ul>
									<li>
										izgradnja načinov za spopadanje s
										stresom (komunikacija z relevantnimi
										osebami v delovnem in zasebnem
										življenju, počitek, prioretizacija
										obveznosti)
									</li>
									<li>
										Izgradnja načinov za preventivno
										spopadanje s stresom (skrb za lastno
										fizično in mentalno zdravje z
										meditacijo, gibanjem in hranilno
										prehrano).
									</li>
								</ul>
								<p>
									Ne pozabite, da je ključno, da si vsak dan
									vzamete vsaj nekaj časa zase, v okviru
									katerega lahko razmislite o svojih ciljih
									kot tudi morebitnih izzivih, s katerimi se
									soočate. Na ta način se boste naučili
									prioretizirati naloge kot tudi prepoznavati
									svoje občutke, zaradi česar se boste tekom
									dneva lažje spopadali z obveznostmi v
									zasebnem in delovnem okolju.&nbsp;
								</p>
							</div>
						) : (
							<div>
								<p>
									You have managed to achieve work-life
									balance and manage stress effectively. It is
									important to protect and maintain this state
									as well. With that in mind, it's great to
									follow a personalized stress management plan
									that you can easily make yourself. A plan
									can only contain two basic categories:&nbsp;
								</p>
								<ul>
									<li>
										Building ways to cope with stress
										(communication with relevant people in
										work and private life, rest,
										prioritization of obligations)
									</li>
									<li>
										Building methods for preventive coping
										with stress (taking care of one's own
										physical and mental health through
										meditation, exercise and a nutritious
										diet).
									</li>
								</ul>
								<p>
									Remember that the key is to set aside at
									least some time for yourself each day to
									reflect on your goals as well as any
									challenges you may be facing. In this way,
									you will learn to prioritize tasks as well
									as recognize your feelings, which will make
									it easier for you to deal with obligations
									in your private and work environment during
									the day.
								</p>
							</div>
						))}
					{points() > 4 &&
						points() <= 9 &&
						(appstate.currentLanguage() === 'slSI' ? (
							<div>
								<p>
									Kljub temu, da stres &scaron;e ne nadzoruje
									va&scaron;ega življenja, se soočate z večjo
									mero stresa kot je priporočjivo za
									va&scaron;e normalno mentalno in fizično
									delovanje. Priporočamo vam izgradnjo
									personaliziranega načrta za upravljanje s
									stresom s pomočjo naslednjih kratkih ampak
									učinkovitih nasvetov:
								</p>
								<ul>
									<li>
										<strong>Naučite se reči NE</strong>.
										Vsak ima meje, ki se jih mora naučiti
										prepoznati. Postavljanje mej pozitivno
										vpliva na va&scaron;e dobro počutje kot
										tudi na izbolj&scaron;ane odnose in
										komunikacijo z drugimi.
									</li>
									<li>
										<strong>Prosite za pomoč</strong>. V
										sodobnem svetu ima veliko ljudi občutek,
										da morajo vse gore premikati sami, ampak
										če nam manjka energije, motivacije ali
										časa za opravljanje nalog, tako sebi kot
										ljudem okoli sebe naredimo več
										&scaron;kode kot koristi.
										Preobremenjenost skomunicirajte z vodjo
										in sodelavci, da lahko tudi oni
										prevzamejo katere obveznosti.
									</li>
									<li>
										<strong>
											Postavite si jasne prioritete
										</strong>
										. Obveznosti si lahko vedno
										prioretiziramo, ker je skorajda
										nemogoče, da so vse enako pomembne. S
										pomočjo digitalnih orodij ali na listu
										papirja si uredite urnik in si tudi
										določite časovno omejitev za vsako izmed
										obveznosti. Tako boste tudi manj
										pozabljali manj&scaron;e zadeve in bolj
										učinkovito porabili svoj čas.
									</li>
									<li>
										<strong>
											Kar lahko stori&scaron; danes, ne
											odla&scaron;aj na jutri
										</strong>
										. Svoje izzive in probleme
										re&scaron;ujte sproti in ne pustite, da
										se vam delo kopiči. Vsak se kdaj sooči z
										nalogo, ki je monotona, ampak se ta
										vseeno (na žalost) ne bo opravila
										sama.&nbsp;
									</li>
									<li>
										<strong>Sprejemajte kompromise</strong>.
										Včasih je pomembno samo to, da je delo
										opravljeno. Vsaka stvar ne rabi biti
										popolna, zato da funkcionira. Temu
										načelu sledite predvsem pri
										ponavljajočih se (nekoliko bolj
										monotonih) nalogah, ki sicer morajo biti
										opravljene pravilno, vendar nam ne
										rabijo vzeti ogromno časa.
									</li>
									<li>
										<strong>
											Spremenite situacije, ki vam
											povzročajo nelagodje
										</strong>
										. Večkrat smo na delovnem mestu v
										situacijah, ki so neprijetne &ndash;
										nestrinjanje s sodelavci, pomanjkanje
										avtonomije, itd. Pri sebi
										identificirajte občutke, ki jih te
										situacije v vas zbujajo in si postavite
										nove standarde za njihovo
										re&scaron;evanje.&nbsp;
									</li>
									<li>
										<strong>Vzamite si čas zase</strong>. To
										vključuje meditacijo, kuhanje, petje,
										sprehajanje ali samo čas za
										razmi&scaron;ljanje. Tudi če je urnik
										popolnoma natrpan, nam že 5 minut
										dnevno, ki si jih vzamemo zase, pomaga
										pri umiritvi misli in manj&scaron;anju
										prisotnosti stresnih hormonov.
									</li>
									<li>
										<strong>
											Zmanj&scaron;ajte vnos substanc kot
											so kofein, sladkor, alkohol in tobak
										</strong>
										. (Pre)večkrat se nam zdi, da so prav te
										razvade tiste, ki spodbujajo na&scaron;e
										optimalno delovanje. Kofein in sladkor
										samo spodbujata t. i. energijske padce,
										ko njun učinek popusti, alkohol in tobak
										pa krepita možnost resnej&scaron;ih
										zdravstvenih težav. Že prehod iz
										kofeinske na brezkofeinsko kavo bo
										pozitivno vplival na va&scaron;e
										počutje, obenem pa se ne rabite
										odpovedati svoji skodelici kave.
									</li>
									<li>
										<strong>
											Vedno prioretizirajte počitek
										</strong>
										. Dovolj dolg in miren spanec je
										predpogoj za normalno člove&scaron;ko
										delovanje. Naj vam bo doseganje takega
										spanca vedno osrednja prioriteta, ki se
										ji niste pripravljeni odpovedati.&nbsp;
									</li>
								</ul>
							</div>
						) : (
							<div>
								<p>
									Even though stress is not yet controlling
									your life, you are experiencing more stress
									than is recommended for your normal mental
									and physical functioning. We encourage you
									to build a personalized stress management
									plan using the following short but effective
									tips:
								</p>
								<ul>
									<li>
										<strong>Learn to say NO</strong>.
										Everyone has limits that they must learn
										to recognize. Setting boundaries has a
										positive effect on your well-being as
										well as improved relationships and
										communication with others.
									</li>
									<li>
										<strong>Ask for help</strong>. In
										today's world, many people feel like
										they have to move all the mountains
										themselves, but if we lack the energy,
										motivation or time to complete the
										tasks, we do more harm than good to both
										ourselves and the people around us.
										Communicate the overload with the
										manager and colleagues so that they too
										can take on some responsibilities.
									</li>
									<li>
										<strong>Set clear priorities</strong>.
										Obligations can always be prioritized
										because it is almost impossible for all
										of them to be equally important. With
										the help of digital tools or on a piece
										of paper, organize your schedule and
										also set a time limit for each of the
										obligations. This way you will forget
										less about minor matters and spend your
										time more efficiently.
									</li>
									<li>
										<strong>
											What you can do today, don't put off
											until tomorrow
										</strong>
										. Solve your challenges and problems on
										the fly and don't let your work pile up.
										At some point, everyone is faced with a
										task that is monotonous, but it will
										(unfortunately) not be done by itself.
									</li>
									<li>
										<strong>Accept compromises</strong>.
										Sometimes all that matters is getting
										the job done. Not everything needs to be
										perfect in order to function. You follow
										this principle especially for repetitive
										(somewhat more monotonous) tasks, which
										must be done correctly, but do not need
										to take a lot of time.
									</li>
									<li>
										<strong>
											Change situations that make you
											uncomfortable
										</strong>
										. We are often in situations at work
										that are unpleasant - disagreement with
										colleagues, lack of autonomy, etc.
										Identify the feelings that these
										situations evoke in you and set new
										standards for dealing with them.
									</li>
									<li>
										<strong>Take time for yourself</strong>.
										This includes meditation, cooking,
										singing, walking, or just thinking. Even
										if the schedule is completely packed,
										even 5 minutes a day, which we take for
										ourselves, helps to calm our thoughts
										and reduce the presence of stress
										hormones.
									</li>
									<li>
										<strong>
											Reduce the intake of substances such
											as caffeine, sugar, alcohol and
											tobacco
										</strong>
										. (Too) many times it seems to us that
										it is precisely these vices that promote
										our optimal functioning. Caffeine and
										sugar only stimulate energy drops when
										their effect wears off, and alcohol and
										tobacco increase the possibility of more
										serious health problems. Just switching
										from caffeinated to decaffeinated coffee
										will have a positive effect on your
										well-being, but at the same time, you
										don't have to give up your cup of
										coffee.
									</li>
									<li>
										<strong>Always prioritize rest</strong>.
										Sufficiently long and restful sleep is a
										prerequisite for normal human
										functioning. Let achieving such sleep
										always be your central priority, which
										you are not ready to give up.
									</li>
								</ul>
							</div>
						))}
					{points() > 9 &&
						(appstate.currentLanguage() === 'slSI' ? (
							<div>
								<p>
									Žal je stres že začel prevzemati nadzor na
									va&scaron;im življenjem. Tako
									izku&scaron;anje stresa sicer kaže na veliko
									mero želje po osebnem uspehu, kakorkoli pa
									ne morete večno sami premikati gora. Nujno
									je, da se s stresom spopadete, da se
									izognete resnej&scaron;im zdravstvenim
									posledicam, ki bi lahko ogrozile va&scaron;e
									vsakdanje delovanje.&nbsp;
								</p>
								<p>
									Največ lahko za učinkovito upravljanje s
									stresom gotovo storite sami. Naredite prvi
									korak in upo&scaron;tevajte katerega izmed
									spodnjih nasvetov:
								</p>
								<ul>
									<li>
										<strong>
											Zmanj&scaron;ajte obseg mentalnega
											bremena
										</strong>
										. Prioretizirajte naloge, ki so
										vsebinsko najpomembnej&scaron;e, medtem
										ko manj pomembne naloge mentalno
										&raquo;potisnete na stran&laquo;. Seveda
										je tudi manj pomembne naloge potrebno
										opraviti, ampak je pomembno, da v svojih
										mislim pozornost posvečate samo stvarem,
										ki nosijo večjo pomembnost.&nbsp;
									</li>
									<li>
										<strong>Naučite se reči NE</strong>.
										Vsak ima meje, ki se jih mora naučiti
										prepoznati. Postavljanje mej pozitivno
										vpliva na va&scaron;e dobro počutje kot
										tudi na izbolj&scaron;ane odnose in
										komunikacijo z drugimi.
									</li>
									<li>
										<strong>Prosite za pomoč</strong>. V
										sodobnem svetu ima veliko ljudi občutek,
										da morajo vse gore premikati sami, ampak
										če nam manjka energije, motivacije ali
										časa za opravljanje nalog, tako sebi kot
										ljudem okoli sebe naredimo več
										&scaron;kode kot koristi.
										Preobremenjenost skomunicirajte z vodjo
										in sodelavci, da lahko tudi oni
										prevzamejo katere obveznosti.
									</li>
									<li>
										<strong>Sprejemajte kompromise</strong>.
										Včasih je pomembno samo to, da je delo
										opravljeno. Vsaka stvar ne rabi biti
										popolna, zato da funkcionira. Temu
										načelu sledite predvsem pri
										ponavljajočih se (nekoliko bolj
										monotonih) nalogah, ki sicer morajo biti
										opravljene pravilno, vendar nam ne
										rabijo vzeti ogromno časa.
									</li>
									<li>
										<strong>
											Zmanj&scaron;ajte vnos substanc kot
											so kofein, sladkor, alkohol in tobak
										</strong>
										. (Pre)večkrat se nam zdi, da so prav te
										razvade tiste, ki spodbujajo na&scaron;e
										optimalno delovanje. Kofein in sladkor
										samo spodbujata t. i. energijske padce,
										ko njun učinek popusti, alkohol in tobak
										pa krepita možnost resnej&scaron;ih
										zdravstvenih težav. Že prehod iz
										kofeinske na brezkofeinsko kavo bo
										pozitivno vplival na va&scaron;e
										počutje, obenem pa se ne rabite
										odpovedati svoji skodelici kave.
									</li>
									<li>
										<strong>Vzamite si čas zase</strong>. To
										vključuje meditacijo, kuhanje, petje,
										sprehajanje ali samo čas za
										razmi&scaron;ljanje. Tudi če je urnik
										popolnoma natrpan, nam že 5 minut
										dnevno, ki si jih vzamemo zase, pomaga
										pri umiritvi misli in manj&scaron;anju
										prisotnosti stresnih hormonov.
									</li>
									<li>
										<strong>
											Vedno prioretizirajte počitek
										</strong>
										. Dovolj dolg in miren spanec je
										predpogoj za normalno člove&scaron;ko
										delovanje. Naj vam bo doseganje takega
										spanca vedno osrednja prioriteta, ki se
										ji niste pripravljeni odpovedati.&nbsp;
									</li>
								</ul>
								<p>
									<br />
								</p>
								<p>
									Svetujemo vam, da se, v kolikor že dlje časa
									izku&scaron;ate katerega od na&scaron;tetih
									simptomov, pogovorite z osebnim zdravnikom:
								</p>
								<ul>
									<li>pomanjkanje apetita,</li>
									<li>panični napadi,</li>
									<li>težave z dihanjem,</li>
									<li>bolečine v mi&scaron;icah,</li>
									<li>pogosti glavoboli,</li>
									<li>prebavne motnje,</li>
									<li>
										občutki žalosti, &raquo;praznine&laquo;
										in brezvrednosti.
									</li>
								</ul>
							</div>
						) : (
							<div>
								<p>
									Unfortunately, stress has already begun to
									take control of your life. Experiencing
									stress in this way indicates a great deal of
									desire for personal success, but you can't
									move mountains by yourself forever. It is
									imperative that you deal with stress to
									avoid more serious health consequences that
									could compromise your daily functioning.
								</p>
								<p>
									You can certainly do the most for effective
									stress management yourself. Take the first
									step and follow any of the tips below:
								</p>
								<ul>
									<li>
										<strong>
											Reduce the amount of mental burden
										</strong>
										. Prioritize the tasks that are most
										important in terms of content, while
										mentally "pushing aside" the less
										important tasks. Of course, less
										important tasks also need to be done,
										but it is important that in your
										thoughts you pay attention only to
										things that carry greater importance.
									</li>
									<li>
										<strong>Learn to say NO</strong>.
										Everyone has limits that they must learn
										to recognize. Setting boundaries has a
										positive effect on your well-being as
										well as improved relationships and
										communication with others.
									</li>
									<li>
										<strong>Ask for help</strong>. In
										today's world, many people feel like
										they have to move all the mountains
										themselves, but if we lack the energy,
										motivation or time to complete the
										tasks, we do more harm than good to both
										ourselves and the people around us.
										Communicate the overload with the
										manager and colleagues so that they too
										can take on some responsibilities.
									</li>
									<li>
										<strong>Accept compromises</strong>.
										Sometimes all that matters is getting
										the job done. Not everything needs to be
										perfect in order to function. You follow
										this principle especially for repetitive
										(somewhat more monotonous) tasks, which
										must be done correctly, but do not need
										to take a lot of time.
									</li>
									<li>
										<strong>
											Reduce the intake of substances such
											as caffeine, sugar, alcohol and
											tobacco
										</strong>
										. (Too) many times it seems to us that
										it is precisely these vices that promote
										our optimal functioning. Caffeine and
										sugar only stimulate energy drops when
										their effect wears off, and alcohol and
										tobacco increase the possibility of more
										serious health problems. Just switching
										from caffeinated to decaffeinated coffee
										will have a positive effect on your
										well-being, but at the same time, you
										don't have to give up your cup of
										coffee.
									</li>
									<li>
										<strong>Take time for yourself</strong>.
										This includes meditation, cooking,
										singing, walking, or just thinking. Even
										if the schedule is completely packed,
										even 5 minutes a day, which we take for
										ourselves, helps to calm our thoughts
										and reduce the presence of stress
										hormones.
									</li>
									<li>
										<strong>Always prioritize rest</strong>.
										Sufficiently long and restful sleep is a
										prerequisite for normal human
										functioning. Make achieving such sleep
										always your top priority, which you are
										not ready to give up.
									</li>
								</ul>
								<p>
									<br />
								</p>
								<p>
									We advise you, if you have been experiencing
									any of the following symptoms for some time,
									to talk to your personal doctor:
								</p>
								<ul>
									<li>Lack of appetite,</li>
									<li>Panic attacks,</li>
									<li>Breathing difficulties,</li>
									<li>Muscle pains,</li>
									<li>Frequent headaches,</li>
									<li>Digestive disorders,</li>
									<li>
										Feelings of sadness, "emptiness", and
										worthlessness.
									</li>
								</ul>
							</div>
						))}
				</div>
				<div className={'mt-5'}>
					<div
						className={
							'flex justify-center items-center border-t pt-8'
						}
					>
						<button
							className={'button-primary reversed'}
							onClick={() => {
								setQuestionsAndAnswers(
									initialQuestionsAndAnswers(),
								);

								resetAnswersInLocalStorage();
								setQuestionsAndAnswers(
									initialQuestionsAndAnswers(),
								);
								setIsStarted(false);
								setIsFinished(false);
								setCurrentQuestion(0);
							}}
						>
							{appstate.currentLanguage() === 'slSI'
								? 'Ponovno reši kviz'
								: 'Take the quiz again'}
						</button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div
			className={
				'w-full cloud-bg-light text-black h-124 mt-4 rounded shadow border overflow-hidden p-8 flex flex-col justify-center items-center gap-8 pb-24 relative'
			}
		>
			<div
				className={
					'absolute w-full h-full top-0 left-0 z-0 opacity-15 blur-sm text-center'
				}
				style={{
					backgroundImage: `url(${tw1})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			/>
			<div>
				<h1
					className={
						'text-primary-500 text-xs lg:text-2xl font-bold z-20 text-center'
					}
				>
					{questionsAndAnswers[currentQuestion].question}
				</h1>
			</div>
			<div
				className={`flex ${
					currentQuestion === -1
						? 'flex-row justify-center'
						: 'flex-col'
				} gap-4 z-20`}
			>
				{getAnswersArray(
					questionsAndAnswers[currentQuestion].answers,
				).map((a, i) => {
					return (
						<button
							key={a}
							className={`button-primary !px-14 z-20 shadow ${
								currentQuestion === -1 && 'w-1/3 h-32 !text-2xl'
							}`}
							onClick={() => {
								const updatedQuestionsAndAnswers =
									questionsAndAnswers.map((q, i) => {
										if (i === currentQuestion) {
											return {
												...q,
												chosenAnswer: a,
											};
										}

										return q;
									});

								setQuestionsAndAnswers(
									updatedQuestionsAndAnswers,
								);

								if (
									currentQuestion + 1 >
									questionsAndAnswers.length - 1
								) {
									setIsFinished(true);
									saveAnswersToLocalStorage();
								} else {
									setCurrentQuestion(currentQuestion + 1);
								}
							}}
						>
							{a}
						</button>
					);
				})}
			</div>
			<div className={'absolute bottom-0 left-0 mb-5 ml-5 z-20'}>
				{currentQuestion !== 0 && (
					<button
						className={'button-primary reversed'}
						onClick={() => {
							setCurrentQuestion(currentQuestion - 1);
							setIsFinished(false);
						}}
					>
						{getLocaledString('Nazaj', 'Back')}
					</button>
				)}
			</div>
		</div>
	);
}

export default MeasuresQuiz2;
